import React, {
    createContext,
    useContext,
    useState,
    useEffect,
    useCallback,
  } from "react";
  import {
    getPagos,
    getPagoById,
    createPago,
    updatePago,
    deletePago,
  } from "../services/finanzasService";
import { useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
  
  const FinanzasContext = createContext();
  
  export const useFinanzas = () => {
    return useContext(FinanzasContext);
  };
  
  export const FinanzasProvider = ({ children }) => {
    const location = useLocation();
    const { user } = useAuth(); // Obtener el usuario autenticado
    const [pagos, setPagos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagosLoaded, setPagosLoaded] = useState(false);
  
    // Memorizar fetchPagos antes de usarlo
    const fetchPagos = useCallback(async (force = false) => {
      if (!pagosLoaded || force) {
        if (user?.rol_id !== 1 && user?.rol_id !== 3) {
          // console.warn("El rol no está autorizado para obtener pagos.");
          return;
        }
  
        setLoading(true);
        try {
          const data = await getPagos();
          setPagos(data.data || []);
          setPagosLoaded(true);
        } catch (error) {
        } finally {
          setLoading(false);
        }
      }
    }, [pagosLoaded, user?.rol_id]);
  
    // useEffect que usa fetchPagos
    useEffect(() => {
      if (
        !pagos.length &&
        (location.pathname === "/finanzas" || location.pathname === "/dashboard" || location.pathname === "/detalles")
      ) {
        fetchPagos(); // Llama a la función para cargar los pagos solo si el rol es válido
      }
    }, [pagos, fetchPagos, location.pathname]);
  
    const fetchPagoById = useCallback(
      async (id) => {
        try {
          const existingPago = pagos.find((pago) => pago.pago_id === id);
          if (existingPago) {
            return existingPago;
          }
          setLoading(true);
          const pago = await getPagoById(id);
          return pago;
        } catch (error) {
          throw error;
        } finally {
          setLoading(false);
        }
      },
      [pagos]
    );
  
    const addPago = async (pago) => {
      const response = await createPago(pago);
      await fetchPagos(true);
      return response;
    };
  
    const editPago = async (id, updatedPago) => {
      try {
        setLoading(true);
        const response = await updatePago(id, updatedPago);
        await fetchPagos(true);
        return response;
      } catch (error) {
        throw error;
      } finally {
        setLoading(false);
      }
    };
  
    const removePago = async (id) => {
      try {
        await deletePago(id);
        setPagos((prev) => prev.filter((pago) => pago.pago_id !== id)); // Remove pago from state
      } catch (error) {
      }
    };
  
    return (
      <FinanzasContext.Provider
        value={{
          pagos,
          loading,
          fetchPagos,
          fetchPagoById,
          addPago,
          editPago,
          removePago,
        }}
      >
        {children}
      </FinanzasContext.Provider>
    );
  };
  